import { ExecuteCallParam, PeerStateResponse, SendSmsParam } from '@@types/Api/Phone';
import { MEMBER_ID } from '@@types/common';

import { URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';

class PhoneApi {
  constructor(private api: Api2) {}

  checkIpPhone = (): Promise<{ ipPhone: boolean }> => {
    return this.api.resultRequester.get(`${URLS.PROJECT_API}/ip-phone`);
  };

  executeCall = (memberId: MEMBER_ID, params: ExecuteCallParam): Promise<void> => {
    return this.api.contentsRequester.post(`${URLS.PROJECT_API}/members/${memberId}/send-phone-push`, {
      ...params,
      callerApplication: 'messenger',
    });
  };

  executeIpPhoneCall = (phoneNumber: string): Promise<void> => {
    return this.api.contentsRequester.post(`${URLS.PROJECT_API}/ip-phone/call`, {
      phoneNumber,
    });
  };

  fetchIpPhoneStatus = (phoneNumber: string): Promise<PeerStateResponse> => {
    return this.api.resultRequester.post(`${URLS.PROJECT_API}/ip-phone/get-peer-status`, { phoneNumber });
  };

  sendSms = (memberId: MEMBER_ID, params: SendSmsParam): Promise<void> => {
    return this.api.contentsRequester.post(`${URLS.PROJECT_API}/members/${memberId}/send-sms-push`, {
      ...params,
      callerApplication: 'messenger',
    });
  };
}

export default PhoneApi;
